/**
 * Closed dates configuration (UK time).
 * Add dates in "YYYY-MM-DD" format.
 * The helper checks if the current date in Europe/London falls on one of these.
 */
const CLOSED_DATES = ["2026-07-15", "2026-07-27"];

const CLOSED_REASON =
  "We are closed today and Monday 27th July for staff training. We apologise for any inconvenience and look forward to serving you again soon!";

/**
 * Returns true if the current UK date matches any closed date.
 */
export function isRestaurantClosed() {
  const ukDate = new Date().toLocaleDateString("en-CA", {
    timeZone: "Europe/London",
  }); // "YYYY-MM-DD"
  return CLOSED_DATES.includes(ukDate);
}

export { CLOSED_DATES, CLOSED_REASON };
